import { Type } from 'class-transformer';
import { forwardRef } from '@angular/core';
import { Role } from '@lemsar/auth/domains/models/role';

export class User {
    public id: string;
    public username: string;
    public email: string;
    public name: string;
    public status: number;
    public parentId: string;
    public userable: any;
    public step: number;
    public createdAt: string;
    public updatedAt: string;
    public nacoUserId: string;

    @Type(forwardRef(() => Role) as any)
    public roles: Role[];

    @Type(forwardRef(() => User) as any)
    public parent?: User;

    public hasRole(role: string): boolean {
        return this.roles.some(r => r.name === role);
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/domains/models/user.ts